module.exports = __webpack_public_path__ + "static/media/2.7d10f28e.jpeg";